// extracted by mini-css-extract-plugin
export default {"reportTabContentHeader":"qcfGz__reportTabContentHeader","reportTitle":"phhYt__reportTitle"};